module.exports = "<cian-af-about-object-condition-type ad=\"conditionType.ad\" form=\"conditionType.form\"></cian-af-about-object-condition-type>"